module.exports = __webpack_public_path__ + "media/images/siq_shield_blank_icon-7bb1c7910af5cefa5a0867fd280af95a.png";